module.exports = __webpack_public_path__ + "img/1.668d9fb9.png";